/* eslint-disable */
import {lista, processar, pegaLista, pegaDados} from '../../services/GenericAPI'
import {Filtro, Join, Left, Where} from "../../models/filtro/filtro";
import {InstagramSCH, getBaseSCH} from "../../search/InstagramSCH"
import {EventBus} from '../../helpers/event-bus'

import {Instagram} from '../../models/instagram'
import _ from 'lodash'

const url = '/instagram'

const state = {
  all: [],
  allLista: [],
  filtro: new Filtro()
}

const getters = {

  listaInstagram: (state) => {
    return state.all
  },
  pegaFiltro: (state) => {
    return state.filtro
  }
}

const actions = {
  searchItem({commit}, search) {
    state.filtro.filters.addFilter('descricao' ,
      "%"+search+"%",
      'like'
    )
  },

  setFiltro({commit}, perPage) {
    commit('SET_FILTRO', InstagramSCH(perPage))
  },

  async setAllInstagram({commit},{onSucesso,onErro}) {
    try {
      const list = (await pegaDados(url+'/get', state.filtro)).data
      commit('SET_INSTAGRAM', list)
      onSucesso()
    } catch (error) {
      onErro()
    }

  },

  async processarInstagram({commit}, {instagram, acao, onSucesso, onErro}) {
    try {
      let res = await processar(url, instagram, acao)
      this.dispatch('geral/setMsgSuccess', res.data.message)
      onSucesso()
    } catch (error) {
      this.dispatch('geral/setObjMsgError', error.response.data)
      onErro()
    }
  }
}

const mutations = {
  SET_INSTAGRAM(state, instagram) {
    state.all = instagram
  },
  SET_FILTRO(state, filtro) {
    state.filtro = filtro
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
